<template>
<div class="form-step-item">
    <div class="panel">
        <h3>Type of Home Patient</h3>
        <div class="form-row">
            <div class="form-group col-12">
                <div class="bax-boxed-radio">
                    <div class="bax-radio">
                        <input type="radio" id="patient_type_nutrition" class="css-checkbox" value="nutrition" v-model="formData.patient_type" />
                        <label for="patient_type_nutrition" class="css-label">Parenteral Nutrition</label>
                    </div>
                    <div class="bax-radio">
                        <input type="radio" id="patient_type_fluids" class="css-checkbox" value="fluids" v-model="formData.patient_type" />
                        <label for="patient_type_fluids" class="css-label">IV fluids only</label>
                    </div>
                </div>
                <span class="form-error" v-if="$v.formData.patient_type.$dirty && !$v.formData.patient_type.required">Required field</span>
            </div>
        </div>
    </div>
    <div class="panel">
        <h3>Patient Details</h3>
        <div class="form-row">
            <div class="form-group col-4">
                <label for="patient_first_name">First name *</label>
                <input type="text" class="form-control" v-model="formData.patient_first_name">
                <span class="form-error" v-if="$v.formData.patient_first_name.$dirty && !$v.formData.patient_first_name.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="patient_last_name">Last name *</label>
                <input type="text" class="form-control" v-model="formData.patient_last_name">
                <span class="form-error" v-if="$v.formData.patient_last_name.$dirty && !$v.formData.patient_last_name.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="patient_dob">Date of birth</label>
                <DateEntry class="form-control" v-model="formData.patient_dob"></DateEntry>
                <span class="form-error" v-if="$v.formData.patient_dob.$dirty && !$v.formData.patient_dob.futureDate">Date not valid</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-4">
                <label for="patient_country">Country</label>
                <select v-model="formData.patient_country" class="form-control">
                    <option class="d-none" value="">- Select -</option>
                    <option v-for="(item, index) in countryOptions" :value="item" v-bind:key="index">
                        {{ item }}
                    </option>
                </select>
                <span class="form-error" v-if="$v.formData.patient_country.$dirty && !$v.formData.patient_country.required">Required field</span>
            </div>
            <div class="form-group col-4" v-if="formData.patient_country === 'New Zealand'">
                <label for="patient_nhi_number">NHI number *</label>
                <input type="text" class="form-control" v-model="formData.patient_nhi_number">
                <span class="form-error" v-if="$v.formData.patient_nhi_number.$dirty && !$v.formData.patient_nhi_number.required">Required field</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-8">
                <label for="patient_address">Address *</label>
                <input type="text" class="form-control" v-model="formData.patient_address">
                <span class="form-error" v-if="$v.formData.patient_address.$dirty && !$v.formData.patient_address.required">Required field</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-4">
                <label for="patient_suburb">Suburb *</label>
                <input type="text" class="form-control" v-model="formData.patient_suburb">
                <span class="form-error" v-if="$v.formData.patient_suburb.$dirty && !$v.formData.patient_suburb.required">Required field</span>
            </div>
            <div class="form-group col-4"  v-if="formData.patient_country === 'Australia'">
                <label for="patient_state">State *</label>
                <select v-model="formData.patient_state" class="form-control">
                    <option class="d-none" value="">- Select -</option>
                    <option v-for="(item, index) in defaultSettings.states" :value="item" v-bind:key="index">
                        {{ item }}
                    </option>
                </select>
                <span class="form-error" v-if="$v.formData.patient_state.$dirty && !$v.formData.patient_state.required">Required field</span>
            </div>
            <div class="form-group col-4" v-if="formData.patient_country === 'New Zealand'">
                <label for="patient_town_city">Town / City *</label>
                <input type="text" class="form-control" v-model="formData.patient_town_city">
                <span class="form-error" v-if="$v.formData.patient_town_city.$dirty && !$v.formData.patient_town_city.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="patient_postcode">Postcode *</label>
                <input type="text" class="form-control" v-model="formData.patient_postcode">
                <span class="form-error" v-if="$v.formData.patient_postcode.$dirty && !$v.formData.patient_postcode.required">Required field</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-4">
                <label for="patient_email">Email address *</label>
                <input type="text" class="form-control" v-model="formData.patient_email">
                <span class="form-error" v-if="$v.formData.patient_email.$dirty && !$v.formData.patient_email.required">Required field</span>
                <span class="form-error" v-if="$v.formData.patient_email.$dirty && !$v.formData.patient_email.email">Not a valid email</span>
            </div>
            <div class="form-group col-4">
                <label for="patient_phone">Phone number *</label>
                <input type="text" class="form-control" v-model="formData.patient_phone">
                <span class="form-error" v-if="$v.formData.patient_phone.$dirty && !$v.formData.patient_phone.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="patient_phone_alt">Alternative phone number</label>
                <input type="text" class="form-control" v-model="formData.patient_phone_alt">
            </div>
        </div>
        <div class="form-row">
            <h5 class="label">Preferred Delivery Day *</h5>
            <div class="form-group col-12 days-radio">
                <div class="bax-boxed-radio">
                    <div class="bax-radio" v-for="(day, index) in workingDays" :key="index">
                        <input type="radio" :id="'delivery_day_' + index" class="css-checkbox" :value="day" v-model="formData.delivery_day" />
                        <label :for="'delivery_day_' + index" class="css-label">{{capitalized(day)}}</label>
                    </div>
                </div>
                <span class="form-error" v-if="$v.formData.delivery_day.$dirty && !$v.formData.delivery_day.required">Required field</span>
            </div>
        </div>
        <p class="note">NOTE: This is to indicate preference of delivery day only. Baxter will confirm the delivery day once the account is set up.</p>
    </div>
</div>
</template>


<script>

import { required, requiredIf, email } from 'vuelidate/lib/validators';
import moment from 'moment';
import DateEntry from '@/components/ui/DateEntry.vue';
import weekdays from '@/constants/weekdays';

export default {
    name: 'FormStep1',
    components: {
        DateEntry,
    },
    props: {
        formData: {
            required: true,
        },
        defaultSettings: {
            required: true,
        },
    },
    data() {
        return {
            workingDays: weekdays.workingdays,
            countryOptions: [
                'Australia',
                'New Zealand',
            ],
            stateOptions: [
                'Australian Capital Territory',
                'New South Wales',
                'Northern Territory',
                'Queensland',
                'South Australia',
                'Tasmania',
                'Victoria',
                'Western Australia',
            ],
        };
    },
    validations: {
        formData: {
            patient_type: {
                required,
            },
            patient_first_name: {
                required,
            },
            patient_last_name: {
                required,
            },
            patient_dob: {
                futureDate(val) {
                    if (val === '') {
                        return true;
                    }
                    if (moment(val, ['DD/MM/YYYY', 'D/M/YYYY'], true).isValid() === false) {
                        return true;
                    }
                    const today = moment().format('DD/MM/YYYY');
                    const now = moment(today, 'DD/MM/YYYY');
                    const date = moment(val, 'DD/MM/YYYY');

                    if (date.diff(now, 'days') > 0) {
                        return false;
                    }

                    return true;
                },
            },
            patient_country: {
                required,
            },
            patient_nhi_number: {
                required: requiredIf(function () {
                    if (this.formData.patient_country === 'New Zealand') {
                        return true;
                    }
                    return false;
                }),
            },
            patient_address: {
                required,
            },
            patient_suburb: {
                required,
            },
            patient_state: {
                required: requiredIf(function () {
                    if (this.formData.patient_country !== 'New Zealand') {
                        return true;
                    }
                    return false;
                }),
            },
            patient_town_city: {
                required: requiredIf(function () {
                    if (this.formData.patient_country === 'New Zealand') {
                        return true;
                    }
                    return false;
                }),
            },
            patient_postcode: {
                required,
            },
            patient_email: {
                required,
                email,
            },
            patient_phone: {
                required,
            },
            delivery_day: {
                required,
            },
        },
    },
    computed: {
    },
    methods: {
        validateForm() {
            this.$v.$touch();
            this.$emit('validation_response', !this.$v.$invalid);
        },
        capitalized(name) {
            const capitalizedFirst = name[0].toUpperCase();
            const rest = name.slice(1);
            return capitalizedFirst + rest;
        },
    },
};
</script>
